import { useEffect, useState } from "react";

export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const normalizedDelay = Math.max(0, delayMs);
  const [delayedActive, setDelayedActive] = useState(
    active && normalizedDelay === 0,
  );

  useEffect(() => {
    if (!active) {
      setDelayedActive(false);
      return;
    }
    if (normalizedDelay === 0) {
      setDelayedActive(true);
      return;
    }

    setDelayedActive(false);
    const timeout = window.setTimeout(
      () => setDelayedActive(true),
      normalizedDelay,
    );
    return () => window.clearTimeout(timeout);
  }, [active, normalizedDelay]);

  return delayedActive;
}
